import { createSlice } from "@reduxjs/toolkit";
import { ICorsicaState } from "../../pages/machines/corsica/type";

const initialState: ICorsicaState = {
  data: null,
  pageSize: 0,
  pageNumber: 0,
  totalCount: 0,
  showLoading: {
    sourceAction: "",
    state: false,
  },
  isLoading: false,
  isSuccess: false,
  corsicaDetails: null,
};

export const corsicaSlice = createSlice({
  name: "corsica",
  initialState,
  reducers: {
    setLoading: (state, action) => {
      const { sourceAction, isLoading, isSuccess } = action.payload;
      state.showLoading = {
        sourceAction: sourceAction,
        state: true,
      };
      state.isLoading = isLoading ? isLoading : false;
      state.isSuccess = isSuccess ? isSuccess : false;
    },
    resetLoading: (state, action) => {
      const { isLoading, isSuccess } = action.payload;
      state.showLoading = {
        sourceAction: "",
        state: false,
      };
      state.isLoading = isLoading ? isLoading : false;
      state.isSuccess = isSuccess ? isSuccess : false;
    },
    replaceCorsica: (state, action) => {
      const { data, pageSize, pageNumber, totalCount } = action.payload;
      state.data = data;
      state.pageSize = pageSize;
      state.pageNumber = pageNumber;
      state.totalCount = totalCount;
    },
    addCorsica: (state, action) => {
      const { data } = action.payload;
      if (state.data) {
        state.data.unshift(data);
      }
      state.corsicaDetails = data;
    },
    updateCorsica: (state, action) => {
      const { localID, data } = action.payload;
      if (localID !== undefined && localID >= 0 && state.data) {
        state.data[localID] = data;
      }
      state.corsicaDetails = data;
    },

    setCorsicaDetails: (state, action) => {
      state.corsicaDetails = action.payload.data;
    },
  },
});

export const corsicaActions = corsicaSlice.actions;
export default corsicaSlice.reducer;
